<template>
  <v-container fluid>
  <v-row>
      <div style="padding-top: 35px; padding-left: 35px">
        กลุ่มบริการ: 
      </div>
      <v-col
        cols="6"
        sm="6"
      >
        <v-select
          v-model="groupModel"
          :items="groupdata"
          multiple
          chips
          :item-text="'title'"
          :item-value="'name'"
          :menu-props="{ top: false, offsetY: true }"
        >
        </v-select>
        
      </v-col>
      <v-col>
        <v-btn class="mt-5 cea-btn" @click="submit()">
          บันทึก
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import Swal from "sweetalert2";
import { domain } from "../services/Constants";

export default {
  name: "developerManageGroup",
  components: {
  },
  data: () => ({
    groupModel: []
  }),
  async created() {
    await this.$store.dispatch("DevData/onGetAllGroupCkan");
    let result = await this.$store.dispatch("DevData/onGetGroupCkan");
    // for (let i = 0; i < result.length; i++){
    //   this.groupModel.push(result[i].name)
    // }
    this.groupModel = result.map(item => item.name);
    
  },
  computed: {
    ...mapState({
      devdata:(state) => state.DevData.dataDev,
      groupdata:(state) => state.DevData.dataGroup,
    }),
  },
  methods: {
    submit(){
      let formData = new FormData();
      formData.append('groupStatus', this.groupModel.join(","));
      axios({
        url: domain + '/api/groupCkan/all',
        method: "POST",
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        if (res){
          Swal.fire({
            icon:"success",
            title:"เรียบร้อย!"
          })
        }else {
          Swal.fire({
            icon:"error",
            title:"Server ผิดพลาด!"
          })
        }

      })
    }
  }
};
</script>
<style>
#app{
  text-align: unset !important;
}
.cea-btn{
  background-color: #FF5101 !important;
  color: white !important;
}
.v-menu__content{
  position: absolute !important;
}

</style>
